import { config, library, dom } from '@fortawesome/fontawesome-svg-core'
config.mutateApproach = 'sync'
// The rendered <svg> does not carry its `far` class, so when a controller swaps the `fa-*` class on it the icon is
// looked up under this style. `fa_icon` defaults to `far`.
config.styleDefault = 'regular'

import {
  faAlarmSnooze,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faArrowLeft,
  faArrowRight,
  faArrowsH,
  faArrowsV,
  faBalanceScale,
  faBan,
  faBolt,
  faBook,
  faBoxes,
  faBoxOpen,
  faBuilding,
  faCalendarCheck,
  faCalendarAlt,
  faCalendarExclamation,
  faCartPlus,
  faChartBar,
  faChartLine,
  faChartLineDown,
  faCheck,
  faCheckDouble,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClipboardCheck,
  faClock,
  faCog,
  faCogs,
  faCoins,
  faCommentAltExclamation,
  faCommentLines,
  faCopy,
  faCloudUpload,
  faCreditCard,
  faDownload,
  faDebug,
  faEdit,
  faEquals,
  faEllipsisH,
  faEnvelope,
  faEnvelopeOpen,
  faExchange,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faExternalLink,
  faExternalLinkSquare,
  faFile,
  faFileAlt,
  faFileCheck,
  faFileCsv,
  faFileDownload,
  faFileEdit,
  faFileExcel,
  faFileImport,
  faFileInvoice,
  faFileInvoiceDollar,
  faFilePdf,
  faFilePlus,
  faFileSearch,
  faFilter,
  faFingerprint,
  faFileSignature,
  faFlagCheckered,
  faHandPointLeft,
  faHandPointRight,
  faHandPointDown,
  faGift,
  faGlasses,
  faGlobe,
  faGrinBeam,
  faHandshake,
  faHome,
  faIdCard,
  faInfo,
  faInfoCircle,
  faInfoSquare,
  faKey,
  faLineColumns,
  faLink,
  faListAlt,
  faLock,
  faLockOpen,
  faMagic,
  faMap,
  faMedal,
  faMeh,
  faMinus,
  faMinusCircle,
  faMoneyCheckAlt,
  faMoneyCheckEdit,
  faPaperclip,
  faPaperPlane,
  faPencil,
  faPercent,
  faPercentage,
  faPiggyBank,
  faPlay,
  faPlus,
  faPlusCircle,
  faPowerOff,
  faQuestionCircle,
  faQuestionSquare,
  faReceipt,
  faRedoAlt,
  faRepeat,
  faSadTear,
  faSave,
  faSearch,
  faShareAlt,
  faSignIn,
  faSignOut,
  faSmile,
  faSms,
  faSpinner,
  faSpinnerThird,
  faStar,
  faStop,
  faSync,
  faTasks,
  faTable,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTrash,
  faUndo,
  faUniversity,
  faUnlink,
  faUpload,
  faUserCheck,
  faUserCircle,
  faUserPlus,
  faUser,
  faUsers,
  faUsersCrown,
  faUserSlash,
  faUserTie,
  faVideo,
  faSmileBeam,
  faSortAlt,
  faCommentDots,
  faSlash as faSlashFar,
} from './fontawesome_icons/regular'

import { faCat, faCheck as faCheckLight, faGrinHearts, faVolleyballBall } from './fontawesome_icons/light'

import { faBarsFilter } from './fontawesome_icons/custom'

import {
  faAngleDown,
  faCircle,
  faArrowAltToBottom,
  faCheckCircle as faCheckCircleFas,
  faSlash as faSlashFas,
  faSquare,
  faSortDown,
  faSortUp,
} from './fontawesome_icons/solid'

// Replace any existing <i> tags with <svg> and set up a MutationObserver to
// continue doing this as the DOM changes.

dom.watch()
library.add(
  faAlarmSnooze,
  faBarsFilter,
  faAngleDoubleDown,
  faAngleDoubleUp,
  faAngleDown,
  faArrowLeft,
  faArrowRight,
  faArrowsH,
  faArrowsV,
  faBalanceScale,
  faBan,
  faBolt,
  faBook,
  faBoxes,
  faBoxOpen,
  faBuilding,
  faCalendarCheck,
  faCalendarAlt,
  faCalendarExclamation,
  faCartPlus,
  faCat,
  faChartBar,
  faChartLine,
  faChartLineDown,
  faCheck,
  faCheckLight,
  faCheckDouble,
  faCircle,
  faCheckCircle,
  faCheckCircleFas,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faChevronUp,
  faClipboardCheck,
  faClock,
  faCog,
  faCogs,
  faCoins,
  faCommentAltExclamation,
  faCommentLines,
  faCommentDots,
  faCopy,
  faCloudUpload,
  faCreditCard,
  faDownload,
  faDebug,
  faEquals,
  faEdit,
  faEllipsisH,
  faEnvelope,
  faEnvelopeOpen,
  faExchange,
  faExclamationTriangle,
  faEye,
  faEyeSlash,
  faExternalLink,
  faExternalLinkSquare,
  faFile,
  faFileAlt,
  faFileCheck,
  faFileCsv,
  faFileDownload,
  faFileEdit,
  faFileExcel,
  faFileImport,
  faFileInvoice,
  faFileInvoiceDollar,
  faFilePdf,
  faFilePlus,
  faFileSearch,
  faFileSignature,
  faFilter,
  faFingerprint,
  faFlagCheckered,
  faGift,
  faGlasses,
  faGlobe,
  faGrinBeam,
  faGrinHearts,
  faHandPointLeft,
  faHandPointRight,
  faHandPointDown,
  faHandshake,
  faHome,
  faHome,
  faIdCard,
  faInfo,
  faFileImport,
  faInfoCircle,
  faInfoSquare,
  faKey,
  faLineColumns,
  faLink,
  faListAlt,
  faLock,
  faLockOpen,
  faMagic,
  faMap,
  faMedal,
  faMeh,
  faMinus,
  faMinusCircle,
  faMoneyCheckAlt,
  faMoneyCheckEdit,
  faPaperclip,
  faPaperPlane,
  faPencil,
  faPercent,
  faPercentage,
  faPiggyBank,
  faPlay,
  faPlus,
  faPlusCircle,
  faPowerOff,
  faQuestionCircle,
  faQuestionSquare,
  faReceipt,
  faRedoAlt,
  faRepeat,
  faSadTear,
  faSave,
  faSearch,
  faShareAlt,
  faSignIn,
  faSignOut,
  faSlashFar,
  faSlashFas,
  faSmile,
  faSms,
  faSortDown,
  faSortUp,
  faSpinner,
  faSpinnerThird,
  faSquare,
  faStar,
  faStop,
  faSync,
  faTable,
  faTasks,
  faThumbsUp,
  faTimes,
  faTimesCircle,
  faTrash,
  faUndo,
  faUniversity,
  faUnlink,
  faUpload,
  faArrowAltToBottom,
  faUserCheck,
  faUserCircle,
  faUserPlus,
  faUser,
  faUsers,
  faUsersCrown,
  faUserSlash,
  faUserTie,
  faVideo,
  faSmileBeam,
  faSortAlt,
  faVolleyballBall,
)
